import { GameComponent } from "../GameComponent";
import {CLASSIC_DEFAULT_GAME_DURATION} from "../../../constants/CONST";
import React, {Dispatch, ReactNode, SetStateAction} from "react";
import {UiButton} from "../../../components/ui-components/button/uiButton";
import {TFunction} from "i18next";
import {StatDetailsIcon, StatIconType} from "../../../components/stats/userStats/statDetailsIcon";

export class GameComponentClassic extends GameComponent {


    tick(prevTime: number) : number{
        if (prevTime > 0) {
            return prevTime - 1;
        } else {
            this.finishGame()
        }
        return CLASSIC_DEFAULT_GAME_DURATION;
    }

    onValidWord(currentScore: number): void {}

    getTimer(): number {
        return CLASSIC_DEFAULT_GAME_DURATION;
    }

    getBottomInfo(currentScore: number, time: number, resetGame: () => void, t: TFunction<"translation", undefined>): ReactNode {
        return (
            <div className="flex justify-between w-full ">
                <p>{t("game.x-words", {count: currentScore})}</p>
                <div className="flex flex-col items-end gap-2">
                    <div className="flex justify-center">
                        <p>{t("game.x-time-left", {count: time})}</p>
                    </div>
                    <UiButton
                        className="flex justify-end"
                        text={t("game.restart")}
                        onClick={resetGame}
                        icon="refresh-arrow"
                    />
                </div>
            </div>
        );
    }

    getTopInfo(t: TFunction<"translation", undefined>, showInformationsPopup: () => void): React.ReactNode {
        return undefined;
    }

    getInformationPopup(t: TFunction<"translation", undefined>, closePopup: Dispatch<SetStateAction<boolean>>): React.ReactNode {
        return undefined;
    }

    getAccessPopup(t: TFunction<"translation", undefined>, closePopup: Dispatch<SetStateAction<boolean>>): React.ReactNode {
        return undefined;
    }

    canUserPlay(t: TFunction<"translation", undefined>, userId: number, gameModeId: number): Promise<{canPlay: boolean, reason?: string}> {
        return Promise.resolve({canPlay: true});
    };

    getStatsFromApiResponse(t: TFunction<"translation", undefined>, response: any) {
        return <>
            <StatDetailsIcon icon={StatIconType.WORDS_TYPED} data={response.score}/>
            <StatDetailsIcon icon={StatIconType.ACCURACY} data={response.accuracy}/>
        </>
    }
}
